export const changePlanDateSelector = (state): string => state.plans.changePlanDate;

export const planSelector = (state): Object => state.plans.data[0];
